import { defineComponent as _defineComponent } from 'vue'
import { useAutoRemovedResizeListener } from '@/composables/misc';
import { provide, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'BysoftSidebar',
  setup(__props, { expose }) {

const expand = ref(window.innerWidth >= 1367);
provide('isSidebarExpanded', expand);

const previousWidth = ref<number>();

useAutoRemovedResizeListener(adjustExpandStatusOnWindowResize);

function adjustExpandStatusOnWindowResize() {
  const width = window.innerWidth;
  if (width !== previousWidth.value && width >= 1367 !== expand.value) {
    previousWidth.value = width;
    expand.value = width >= 1367;
  }
}

function toggle(): void {
  expand.value = !expand.value;
}

expose({ toggle });

return { __sfc: true,expand, previousWidth, adjustExpandStatusOnWindowResize, toggle }
}

})